// Central brand configuration
export const BRAND = {
  name: 'Rare Locals',
  legal_name: 'Virkar Products Private Limited',
  tan: 'PNEV30710B',
  registrations: {
    cin: 'U47912KA2026PTC226698',
    incorporated: '24 August 2026',
    gstin: '29AAMCV6292J1ZG',
    gst_effective: '28 September 2026',
    dpiit: 'DIPP280659',
    dpiit_issued: '2 September 2026',
  },
  tagline: 'Rare in Nature. Local at Heart.',
  categories_tag: 'Coffee \u2022 Tea \u2022 Dehydrated & More',
  contact: {
    email: 'hello@rarelocals.com',
    phone: '+91 91801 02402',
    phone_tel: '+919180102402',
    address_line1: '4th Main, KML, Agara',
    address_line2: 'Bangalore South, Bengaluru - 560034',
    address_state: 'Karnataka, India',
    address: '4th Main KML, Agara, Bangalore South, Bengaluru - 560034, Karnataka, India',
    hours: 'Mon\u2013Sat, 9:30 AM to 6:30 PM',
  },
  social: {
    instagram: '',
    facebook: '',
    youtube: '',
  },
  free_shipping_threshold: 500,
};

// Simple top-level links (still needed for mobile drawer / footer)
export const NAV_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'Shop All', to: '/shop' },
  { label: 'Blog', to: '/blog' },
  { label: 'Our Story', to: '/about' },
  { label: 'Contact', to: '/contact' },
];

// Category tree used by the Category dropdown.
// Children (sub-categories) show on hovering a parent that has `children`.
export const CATEGORY_TREE = [
  { label: 'Coffee', slug: 'coffee' },
  { label: 'Tea', slug: 'tea' },
  {
    label: 'Dehydrated',
    slug: 'dehydrated',
    children: [
      { label: 'Dehydrated Fruits', slug: 'dehydrated-fruits' },
    ],
  },
  { label: 'Spices', slug: 'spices' },
  {
    label: 'Pet Food',
    slug: 'pet-food',
    children: [
      { label: 'Dehydrated Treats', slug: 'pet-dehydrated-treats' },
    ],
  },
];

// Institution Sales top-nav (each links to the same rich B2B page,
// which highlights the relevant section based on slug).
export const INSTITUTION_LINKS = [
  { label: 'Bulk & B2B Supply', to: '/b2b' },
  { label: 'B2B Catalogue', to: '/institution-sales/catalogue' },
  { label: 'Our Manufacturing Plant', to: '/institution-sales/plant' },
];
